import { useState } from 'react';
import { DataService } from '../utils/dataService';

type BlacklistParams = {
  typeDocument: string;
  numberDocument: string;
};

type BlacklistResult = {
  restrictedUser: boolean | null;
  loading: boolean;
  error: boolean;
  checkBlacklist: (params: BlacklistParams) => Promise<boolean | null>;
};

const useBlacklist = (): BlacklistResult => {
  const [restrictedUser, setRestrictedUser] = useState<boolean | null>(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const checkBlacklist = async ({ typeDocument, numberDocument }: BlacklistParams): Promise<boolean | null> => {
    setLoading(true);
    setError(false);
    try {
      const _dataService = new DataService();
      const res = await _dataService.post('/api/v2/check-list', { source: 'davivienda', typeDocument, numberDocument });
      const isRestricted = Boolean(res?.data?.data?.restrictedUser);
      setRestrictedUser(isRestricted);
      return isRestricted;
    } catch {
      setError(true);
      setRestrictedUser(null);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { restrictedUser, loading, error, checkBlacklist };
};

export default useBlacklist;
